<template>
  <nav class="side-nav">
    <div
      v-for="(tab, index) in menuItems"
      id="itemHover"
      :key="index"
      style="margin-top:25px; margin-bottom: 30px;"
      class="main-navigation__item cursor-pointer"
      @click="changeTab(tab.link)"
    >
      <div style="width: 100%; text-align:center">
        <base-icon
          class="mainIcon"
          :icon="tab.icon"
          @click="changeTab(tab.link)"
        />
      </div>
      <div
        style="width: 100%;
        text-align:center;
        margin-top:10px;
        font-size:9pt"
        :class="{'activeTab': index === currentTabIndex}"
        @click="changeTab(tab.link)"
      >
        {{ tab.text }}
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'LeftNavigation',
  data() {
    return {
      isSwitchUi: false,
      menu: null,
      active: false,
    };
  },
  computed: {
    currentTabIndex() {
      const sortedSearch = this.menuItems.map((t, index) => ({ position: this.currentRoute().search(t.link.split('?')[0]), index }))
        .filter((route) => route.position >= 0).sort((r1, r2) => r1.position - r2.position);
      return sortedSearch.length ? sortedSearch[0].index : -1;
    },
    isManager() {
      const role = this.user ? this.user.profile.role : this.role;
      return role.includes('manager');
    },
    isStylist() {
      const role = this.user ? this.user.profile.role : this.role;
      return role.includes('stylist');
    },
    // Returns an User object if the account is used as 'View as'
    isSuperuser() {
      return this.$store.getters['account/isSuperuser'];
    },
    superuser() {
      return this.$store.state.account.superuser.user;
    },
    user() {
      return this.$store.state.account.user;
    },
    adminOptions() {
      return this.$store.state.account.isAdminMode;
    },
    menuItems() {
      const catalogEnabled = this.useFeature('product_catalog');

      const stylistMode = this.isStylist && !this.adminOptions;
      const adminMode = this.isManager && this.adminOptions;

      const allTabs = [
        {
          icon: 'sidebar_activity',
          text: this.$t('navbar.dashboard'),
          link: 'dashboard',
          show: stylistMode,
        },
        {
          icon: 'sidebar_activity',
          text: this.$t('navbar.dashboard'),
          link: 'admin/dashboard',
          show: adminMode,
        },
        {
          icon: 'sidebar_clients',
          text: this.$t('navbar.clients'),
          link: 'clients',
          show: stylistMode,
        },
        {
          icon: 'sidebar_clients',
          text: this.$t('navbar.clients'),
          link: 'admin/clients',
          show: adminMode,
        },
        {
          icon: 'sidebar_outreach',
          text: this.$t('Outreach'),
          link: 'entries',
          show: stylistMode,
        },
        {
          icon: 'sidebar_album',
          text: this.$t('navbar.assets'),
          link: 'assets',
          show: true,
        },
        {
          icon: 'sidebar_report',
          text: this.$t('navbar.reports'),
          link: 'admin/reports',
          show: adminMode,
        },
        {
          icon: 'sidebar_report',
          text: this.$t('navbar.reports'),
          link: 'reports',
          show: stylistMode,
        },
        {
          icon: 'sidebar_inventory',
          text: this.$t('Inventory'),
          link: 'inventory',
          show: catalogEnabled,
        },
      ];
      const userTabs = allTabs.filter((tab) => tab.show);
      return userTabs;
    },
  },
  methods: {
    currentRoute() {
      // Special cases
      if (this.$route.name === 'admin.team.show') {
        return '/dashboard';
      }
      if (this.$route.query) {
        return this.$route.path.split('?')[0];
      }
      return this.$route.path;
    },
    changeTab(tab) {
      const tabName = tab.split('?')[0];
      const tabBase = tabName.split('/')[0];
      const baseTab = this.$route.path.split('/')[1];

      if (this.$route.path === `/${tabName}`) {
        return;
      } else if (baseTab !== 'admin') {
        if (tabBase === baseTab) {
          this.$router.push(`/${tab}`, () => this.$router.go(0));
          return;
        }
      }
      this.$router.push(`/${tab}`);
    },
    showAdminOptions(show) {
      this.$store.dispatch('account/setAdminMode', show);
      this.$router.push(`/${this.menuItems[0].link}`);
    },
  },
};
</script>
<style>
/* * {
    margin: 0;
    padding: 0;
    outline: none;
    border: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
} */

.side-nav {
  background-color: white;
    border-right: 1px solid #E2E2E2;
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100vh;
    left: 0;
    width: 82px;
    overflow: hidden;
    margin-top: 60px;
}

.logo img {
    width: 50px;
    height: 50px;
}

.side-nav ul li a {
    position: relative;
    color: black;
    font-size: 14px;
    display: table;
    font-weight: bold;
    text-align: center;
}

.icon {
    width: 28px;
    height: 28px;
    font-size: 17px;
    text-align: center;
    display: inline-block;
}

ul li a {
    padding: 25px;
    display: inline-block;
}

@media(max-width: 1023px) {
  .side-nav {
    display: none;
  }
}

.activeTab {
    color: #E7873C !important;
}
#itemHover:hover{
  color: #E7873C !important;
}
.mainIcon{
  width: 24px;
  height: 24px;
}
</style>
